!function() {
    "use strict";
    (a = s || (s = {})).Percentage = "percentage",
    a.FixedAmount = "fixed_amount",
    a.NoDiscount = "no_discount";
    let t = t => {
        var e;
        if (!t)
            return null;
        let i = t.closest(".product-bundle-item");
        return {
            quantity: Number(null == i ? void 0 : i.getAttribute("quantity")),
            discountValue: Number(null == i ? void 0 : i.getAttribute("discountValue")),
            discountType: null !== (e = null == i ? void 0 : i.getAttribute("discountType")) && void 0 !== e ? e : s.NoDiscount
        }
    }
      , e = (t, e) => !!(e || (null == t ? void 0 : t.productCustomPrice) || (null == t ? void 0 : t.hasBundleDiscountActive))
      , i = t => void 0 === t
      , r = (t=0, e) => {
        let i = window.Shopify;
        if (!i || "function" != typeof i.formatMoney)
            throw Error("Shopify.formatMoney is not available.");
        return i.formatMoney(t, e)
    }
      , n = t => {
        var e, i, r;
        return (null === (i = null === (r = t.closest("gp-product")) || void 0 === r ? void 0 : r.querySelector("gp-product-variants")) || void 0 === i ? void 0 : null === (e = i.getState) || void 0 === e ? void 0 : e.call(i)) || ""
    }
    ;
    function o(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    var a, s, l = () => class extends GP.Component {
        connectedCallback() {
            let t = this.closest("gp-product");
            if ((null == t ? void 0 : t.getState) && t.getState("isReady")) {
                this.rootInit();
                return
            }
            null == t || t.addEventListener("gp:product-init", () => {
                requestAnimationFrame( () => {
                    this.context = null == t ? void 0 : t.context,
                    this.rootInit()
                }
                )
            }
            )
        }
        constructor(t) {
            super(),
            o(this, "initFunc", void 0),
            o(this, "rootInit", () => {
                let t = this.closest(".gps > section");
                if (null == t ? void 0 : t.classList.contains("gps-lazy")) {
                    null == t || t.addEventListener("GpLazyLoaded", this.rootInit);
                    return
                }
                null == t || t.removeEventListener("GpLazyLoaded", this.rootInit),
                this.initFunc && this.initFunc()
            }
            ),
            this.initFunc = t
        }
    }
    ;
    function c(t, e, i) {
        return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[e] = i,
        t
    }
    var d = () => class extends l() {
        handleInternalBundleState(t) {
            var e, i, r, n;
            let o = (null !== (r = this.getState("priceType")) && void 0 !== r ? r : "regular") === "compare"
              , {bundlePrice: a="", bundleComparePrice: s="", price: l=0, comparePrice: c=0} = null !== (n = null === (e = t.store) || void 0 === e ? void 0 : e.getState()) && void 0 !== n ? n : {}
              , d = (t, e) => {
                this.$textElement && (this.$textElement.innerHTML = o ? e : t),
                this.toggleHiddenBasedOnPrices(c, l)
            }
            ;
            d(a, s),
            null == t || null === (i = t.store) || void 0 === i || i.subscribe(t => {
                d(t.bundlePrice, t.bundleComparePrice)
            }
            )
        }
        constructor() {
            super( () => {
                this.init()
            }
            ),
            c(this, "priceType", void 0),
            c(this, "isComparePrice", void 0),
            c(this, "moneyFormat", void 0),
            c(this, "bundleItem", void 0),
            c(this, "productBundleItem", this.closest(".product-bundle-item")),
            c(this, "cachedVariantSelection", void 0),
            c(this, "productEl", this.closest("gp-product")),
            c(this, "$textElement", this.querySelector(".gp-price")),
            c(this, "observerInit", () => {
                var i, r;
                this.bundleItem = t(this.productBundleItem);
                let o = (null === (i = null === (r = this.productEl) || void 0 === r ? void 0 : r.querySelector(".quantityClass")) || void 0 === i ? void 0 : i.getAttribute("data-price")) === "true" || !!this.productBundleItem
                  , a = this.getContext("variantSelected");
                if (o && a) {
                    let t = this.getContext("quantity") || 1;
                    this.applyNormalPrice(a, t)
                }
                this.subscribeContext( (t, i) => {
                    var r, a;
                    if (!this.hasContextUpdated(t, i))
                        return;
                    this.setContext("isSubmit", !1),
                    t.variantSelected && (this.cachedVariantSelection = t.variantSelected);
                    let s = n(this);
                    if (!t.variantSelected && s.currentSelected)
                        return this.classList.add("!gp-hidden");
                    if (this.classList.contains("!gp-hidden") && this.classList.remove("!gp-hidden"),
                    e(t, this.bundleItem))
                        return;
                    this.checkHiddenComparePrice(t.variantSelected);
                    let l = t.quantity || 1;
                    this.cachedVariantSelection && this.applyNormalPrice(this.cachedVariantSelection, o ? l : 1);
                    let c = "regular" === this.priceType ? "price" : "compare_at_price"
                      , d = null !== (a = null === (r = t.variantSelected) || void 0 === r ? void 0 : r[c]) && void 0 !== a ? a : 0;
                    this.dispatchInteractionChangePrice(d / 100, this.isComparePrice ? "compare-price" : "price")
                }
                )
            }
            ),
            c(this, "init", async () => {
                this.priceType = this.getTypePrice(),
                this.isComparePrice = "compare" === this.priceType,
                this.moneyFormat = this.getState("moneyFormat"),
                this.setDefaultVariantSelectIfNotSelected(),
                this.setContext("moneyFormat", this.moneyFormat),
                this.observerInit(),
                this.processBundleDiscount()
            }
            ),
            c(this, "setDefaultVariantSelectIfNotSelected", () => {
                var t;
                this.cachedVariantSelection || (this.cachedVariantSelection = null === (t = this.closest("gp-product")) || void 0 === t ? void 0 : t.getState("variantSelected"))
            }
            ),
            c(this, "hasContextUpdated", (t, e) => {
                var i, r, n, o, a, s;
                return (null === (i = t.variantSelected) || void 0 === i ? void 0 : i.id) !== (null === (r = e.variantSelected) || void 0 === r ? void 0 : r.id) || t.quantity !== e.quantity || (null === (n = t.variantSelected) || void 0 === n ? void 0 : n.price) !== (null === (o = e.variantSelected) || void 0 === o ? void 0 : o.price) || (null === (a = t.variantSelected) || void 0 === a ? void 0 : a.compare_at_price) !== (null === (s = e.variantSelected) || void 0 === s ? void 0 : s.compare_at_price)
            }
            ),
            c(this, "toggleHiddenBasedOnPrices", (t, e) => {
                if (!Number.isFinite(t) || !Number.isFinite(e)) {
                    console.warn("Invalid input: 'comparePrice' and 'price' must be finite numbers.");
                    return
                }
                let i = this.isComparePrice && (t <= 0 || t <= e);
                this.setAttribute("data-hidden", i ? "true" : "false")
            }
            ),
            c(this, "applyCustomBundlePricing", t => {
                var e;
                let {price: i=0, comparePrice: n=0} = null !== (e = t.productCustomPrice) && void 0 !== e ? e : {};
                if (this.$textElement) {
                    let t = this.isComparePrice ? r(n, this.moneyFormat) : r(i, this.moneyFormat);
                    this.$textElement.innerHTML = t
                }
                this.toggleHiddenBasedOnPrices(n, i)
            }
            ),
            c(this, "handleExternalBundlePricing", () => {
                this.subscribeContext(t => {
                    var e;
                    i(null == t ? void 0 : t.hasBundleDiscountActive) || t.isSubmit || (t.productCustomPrice ? this.applyCustomBundlePricing(t) : this.applyNormalPrice(t.variantSelected, null !== (e = t.quantity) && void 0 !== e ? e : 1))
                }
                )
            }
            ),
            c(this, "processBundleDiscount", () => {
                let t = this.closest("gp-product-bundle-discount-item");
                if (!t) {
                    this.handleExternalBundlePricing();
                    return
                }
                t.store ? this.handleInternalBundleState(t) : window.addEventListener("gp:product-bundle-store-ready", () => {
                    this.handleInternalBundleState(t)
                }
                )
            }
            ),
            c(this, "dispatchInteractionChangePrice", (t, e) => {
                this.trigger && (this.trigger({
                    event: "price" === e ? "gp:rollback:price-change" : "gp:rollback:compare-price-change",
                    data: t
                }),
                this.trigger({
                    event: "price" === e ? "gp:price-change" : "gp:compare-price-change",
                    data: t
                }))
            }
            ),
            c(this, "applyNormalPrice", (t, e) => {
                let i = this.getPriceText(t, e);
                this.$textElement && (this.$textElement.innerHTML = i)
            }
            ),
            c(this, "checkHiddenComparePrice", t => {
                if (t && this.isComparePrice) {
                    let e = t && t.compare_at_price && t.compare_at_price >= 0 && t.compare_at_price > t.price;
                    e ? this.setAttribute("data-hidden", "false") : this.setAttribute("data-hidden", "true")
                }
            }
            ),
            c(this, "getTypePrice", () => this.getState("priceType") || "regular"),
            c(this, "getShopLocale", () => this.getState("locale")),
            c(this, "getShopCurrency", () => this.getState("currency")),
            c(this, "getPriceText", (t, e=1) => {
                var i;
                let r = "regular" === this.priceType ? "price" : "compare_at_price"
                  , n = null == t ? void 0 : t[r];
                if (null == n || "compare_at_price" === r && !n)
                    return "";
                let o = window.Shopify.formatMoney(`${n * e}`, null !== (i = this.moneyFormat) && void 0 !== i ? i : "${{amount}}");
                return o
            }
            )
        }
    }
    ;
    let u = () => {
        window.removeEventListener("gp-global-loaded", u),
        customElements.get("gp-product-price") || customElements.define("gp-product-price", d())
    }
    ;
    "completed" === window.gpReadyState ? u() : window.addEventListener("gp-global-loaded", u)
}();
